export enum SearchTypes {
    Batch           = "batch",
    Project         = "project",
    CadastralNumber = "number",
}

